<template>
  <div class="dk-page pb-100">
    <!-- Loading -->
    <div class="dk-loading" v-if="loading">
      <b-spinner variant="primary" style="width:3rem;height:3rem;"></b-spinner>
      <p class="mt-20 font-18 font-weight-6 text-primary">Memuat data...</p>
    </div>

    <template v-else>
      <!-- Hero -->
      <div class="dk-hero">
        <div class="dk-hero-deco-1"></div>
        <div class="dk-hero-deco-2"></div>
        <div class="container-standar dk-hero-inner">
          <router-link to="/potensi-kampung" class="dk-breadcrumb">
            <i class="fa fa-arrow-left mr-2"></i> Kembali ke Potensi Kampung
          </router-link>
          <div class="dk-tipe-badge">{{ identitas.tipe }}</div>
          <h1 class="dk-hero-title">{{ identitas.nama }}</h1>
          <div class="dk-hero-meta">
            <span class="dk-meta-item"><i class="fa fa-barcode mr-1"></i>{{ identitas.kode }}</span>
            <span class="dk-meta-item"><i class="fa fa-map-marker mr-1"></i>Provinsi PAPUA</span>
            <span class="dk-meta-item" v-if="identitas.idm_status">
              <i class="fa fa-star mr-1"></i>IDM: {{ identitas.idm_status }}
            </span>
          </div>
        </div>
      </div>

      <!-- Stats Bar -->
      <div class="dk-stats-bar">
        <div class="container-standar">
          <div class="dk-stats-row">
            <div class="dk-stat-card">
              <div class="dk-stat-icon c-blue"><i class="fa fa-users"></i></div>
              <div>
                <div class="dk-stat-val">{{ kependudukan.total_penduduk }}</div>
                <div class="dk-stat-lbl">Total Penduduk</div>
              </div>
            </div>
            <div class="dk-stat-card">
              <div class="dk-stat-icon c-green"><i class="fa fa-home"></i></div>
              <div>
                <div class="dk-stat-val">{{ dataKeluarga.total_keluarga }}</div>
                <div class="dk-stat-lbl">Kepala Keluarga</div>
              </div>
            </div>
            <div class="dk-stat-card">
              <div class="dk-stat-icon c-orange"><i class="fa fa-user-circle"></i></div>
              <div>
                <div class="dk-stat-val">{{ kependudukan.oap }}</div>
                <div class="dk-stat-lbl">Penduduk OAP</div>
              </div>
            </div>
            <div class="dk-stat-card">
              <div class="dk-stat-icon c-purple"><i class="fa fa-id-card"></i></div>
              <div>
                <div class="dk-stat-val">{{ kependudukan.cakupan_ktp_persen }}%</div>
                <div class="dk-stat-lbl">Cakupan KTP</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Main Layout -->
      <div class="container-standar mt-30">
        <div class="row">
          <!-- Sidebar -->
          <div class="col-lg-3 mb-30">
            <div class="dk-sidebar">
              <div class="dk-sb-header">
                <div class="dk-sb-avatar"><i class="fa fa-map-marker"></i></div>
                <h4 class="dk-sb-name">{{ identitas.tipe }}<br>{{ identitas.nama }}</h4>
                <span class="dk-sb-kode">{{ identitas.kode }}</span>
              </div>
              <div class="dk-sb-body">
                <div class="dk-sb-row">
                  <div class="dk-sb-icon"><i class="fa fa-user-circle"></i></div>
                  <div>
                    <div class="dk-sb-label">Kepala {{ identitas.tipe }}</div>
                    <div class="dk-sb-val">{{ identitas.ketua || '-' }}</div>
                  </div>
                </div>
                <div class="dk-sb-row" v-if="identitas.alamat">
                  <div class="dk-sb-icon"><i class="fa fa-map-pin"></i></div>
                  <div>
                    <div class="dk-sb-label">Alamat</div>
                    <div class="dk-sb-val">{{ identitas.alamat }}, Papua</div>
                  </div>
                </div>
                <div class="dk-sb-row" v-if="identitas.luas_wilayah_km">
                  <div class="dk-sb-icon"><i class="fa fa-expand"></i></div>
                  <div>
                    <div class="dk-sb-label">Luas Wilayah</div>
                    <div class="dk-sb-val">{{ identitas.luas_wilayah_km }} km²</div>
                  </div>
                </div>
                <div class="dk-sb-row" v-if="identitas.tipologi">
                  <div class="dk-sb-icon"><i class="fa fa-layer-group"></i></div>
                  <div>
                    <div class="dk-sb-label">Tipologi</div>
                    <div class="dk-sb-val">{{ identitas.tipologi }}</div>
                  </div>
                </div>
                <div class="dk-sb-row" v-if="identitas.idm_skor">
                  <div class="dk-sb-icon"><i class="fa fa-bar-chart"></i></div>
                  <div>
                    <div class="dk-sb-label">IDM Skor</div>
                    <div class="dk-sb-val">{{ identitas.idm_skor }}</div>
                  </div>
                </div>
              </div>
              <div class="dk-gender-block" v-if="kependudukan.total_penduduk > 0">
                <div class="dk-gender-title">Rasio Gender</div>
                <div class="dk-gender-bar">
                  <div class="dk-g-male" :style="{width: malePercent + '%'}"></div>
                  <div class="dk-g-female" :style="{width: femalePercent + '%'}"></div>
                </div>
                <div class="dk-gender-leg">
                  <span class="dgl-m"><i class="fa fa-circle"></i> L: {{ kependudukan.laki_laki }}</span>
                  <span class="dgl-f"><i class="fa fa-circle"></i> P: {{ kependudukan.perempuan }}</span>
                </div>
              </div>
            </div>
          </div>

          <!-- Tab Area -->
          <div class="col-lg-9">
            <div class="dk-tabs-wrap">
              <!-- Nav -->
              <div class="dk-tab-nav">
                <button
                  v-for="tab in tabs" :key="tab.key"
                  class="dk-tab-btn"
                  :class="{active: activeTab === tab.key}"
                  @click="activeTab = tab.key"
                >
                  <i :class="tab.icon"></i>
                  <span>{{ tab.label }}</span>
                </button>
              </div>

              <!-- PETA -->
              <div class="dk-tab-body" v-show="activeTab === 'peta'">
                <iframe
                  src="https://www.google.com/maps/d/embed?mid=13HHjRpGvZx1PZ1Jipi8rvuv2BXc&hl=en"
                  width="100%" height="480" frameborder="0" class="dk-map-frame"
                ></iframe>
              </div>

              <!-- PROFIL -->
              <div class="dk-tab-body" v-show="activeTab === 'profil'">
                <div class="row mb-24">
                  <div class="col-md-6 mb-16">
                    <div class="dk-visi-card">
                      <div class="dk-vc-icon visi-icon"><i class="fa fa-eye"></i></div>
                      <h5>Visi</h5>
                      <p>{{ identitas.visi || 'Belum tersedia' }}</p>
                    </div>
                  </div>
                  <div class="col-md-6 mb-16">
                    <div class="dk-misi-card">
                      <div class="dk-vc-icon misi-icon"><i class="fa fa-bullseye"></i></div>
                      <h5>Misi</h5>
                      <p>{{ identitas.misi || 'Belum tersedia' }}</p>
                    </div>
                  </div>
                </div>
                <div class="dk-sec-title">Identitas Wilayah</div>
                <div class="dk-info-grid">
                  <div class="dk-ig-item">
                    <span class="dk-ig-lbl">Nama</span>
                    <span class="dk-ig-val">{{ identitas.tipe }} {{ identitas.nama }}</span>
                  </div>
                  <div class="dk-ig-item">
                    <span class="dk-ig-lbl">Kode</span>
                    <span class="dk-ig-val"><code class="dk-code">{{ identitas.kode }}</code></span>
                  </div>
                  <div class="dk-ig-item">
                    <span class="dk-ig-lbl">Tipe</span>
                    <span class="dk-ig-val"><span class="dk-pill primary">{{ identitas.tipe }}</span></span>
                  </div>
                  <div class="dk-ig-item">
                    <span class="dk-ig-lbl">Tipologi</span>
                    <span class="dk-ig-val">{{ identitas.tipologi || '-' }}</span>
                  </div>
                  <div class="dk-ig-item">
                    <span class="dk-ig-lbl">IDM Skor</span>
                    <span class="dk-ig-val">{{ identitas.idm_skor || '-' }}</span>
                  </div>
                  <div class="dk-ig-item">
                    <span class="dk-ig-lbl">IDM Status</span>
                    <span class="dk-ig-val">
                      <span class="dk-pill success" v-if="identitas.idm_status">{{ identitas.idm_status }}</span>
                      <span v-else>-</span>
                    </span>
                  </div>
                  <div class="dk-ig-item">
                    <span class="dk-ig-lbl">IDM Target</span>
                    <span class="dk-ig-val">{{ identitas.idm_target || '-' }}</span>
                  </div>
                  <div class="dk-ig-item">
                    <span class="dk-ig-lbl">Jumlah Industri</span>
                    <span class="dk-ig-val">{{ identitas.jumlah_industri }}</span>
                  </div>
                  <div class="dk-ig-item">
                    <span class="dk-ig-lbl">Provinsi</span>
                    <span class="dk-ig-val">PAPUA</span>
                  </div>
                </div>
              </div>

              <!-- KEPENDUDUKAN -->
              <div class="dk-tab-body" v-show="activeTab === 'kependudukan'">
                <div class="dk-kep-grid">
                  <div class="dk-kep-card">
                    <i class="fa fa-users"></i>
                    <div class="dkc-num">{{ kependudukan.total_penduduk }}</div>
                    <div class="dkc-lbl">Total Penduduk</div>
                  </div>
                  <div class="dk-kep-card green">
                    <i class="fa fa-male"></i>
                    <div class="dkc-num">{{ kependudukan.laki_laki }}</div>
                    <div class="dkc-lbl">Laki-laki</div>
                  </div>
                  <div class="dk-kep-card pink">
                    <i class="fa fa-female"></i>
                    <div class="dkc-num">{{ kependudukan.perempuan }}</div>
                    <div class="dkc-lbl">Perempuan</div>
                  </div>
                  <div class="dk-kep-card orange">
                    <i class="fa fa-id-card"></i>
                    <div class="dkc-num">{{ kependudukan.sudah_ktp }}/{{ kependudukan.wajib_ktp }}</div>
                    <div class="dkc-lbl">KTP</div>
                  </div>
                </div>
                <div class="row mt-24">
                  <div class="col-md-6">
                    <div class="dk-sec-title">Cakupan KTP</div>
                    <div class="dk-prog-item mb-20">
                      <div class="dk-prog-head">
                        <span>Sudah KTP ({{ kependudukan.sudah_ktp }} dari {{ kependudukan.wajib_ktp }})</span>
                        <strong>{{ kependudukan.cakupan_ktp_persen }}%</strong>
                      </div>
                      <div class="dk-prog-track">
                        <div class="dk-prog-fill blue" :style="{width: kependudukan.cakupan_ktp_persen + '%'}"></div>
                      </div>
                    </div>
                    <div class="dk-sec-title">Komposisi OAP</div>
                    <div class="dk-prog-item mb-20">
                      <div class="dk-prog-head">
                        <span>OAP: {{ kependudukan.oap }} | Non-OAP: {{ kependudukan.non_oap }}</span>
                        <strong>{{ oapPercent }}%</strong>
                      </div>
                      <div class="dk-prog-track">
                        <div class="dk-prog-fill green" :style="{width: oapPercent + '%'}"></div>
                      </div>
                    </div>
                    <div v-if="kependudukan.agama && kependudukan.agama.length">
                      <div class="dk-sec-title">Agama</div>
                      <div class="dk-agama-list">
                        <div class="dk-agama-chip" v-for="item in kependudukan.agama" :key="item.kode">
                          <span>{{ labelAgama(item.kode) }}</span>
                          <span class="dac-num">{{ item.total }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="dk-sec-title">Kelompok Umur</div>
                    <div class="dk-umur-list" v-if="kependudukan.kelompok_umur">
                      <div class="dk-umur-row" v-for="(val, key) in kependudukan.kelompok_umur" :key="key">
                        <div class="dk-umur-lbl">{{ key }}</div>
                        <div class="dk-umur-track">
                          <div class="dk-umur-fill" :style="{width: getUmurWidth(val) + '%'}"></div>
                        </div>
                        <div class="dk-umur-num">{{ val }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- DATA KELUARGA -->
              <div class="dk-tab-body" v-show="activeTab === 'keluarga'">
                <div class="dk-kk-row">
                  <div class="dk-kk-card">
                    <i class="fa fa-home"></i>
                    <div class="dkkc-num">{{ dataKeluarga.total_keluarga }}</div>
                    <div class="dkkc-lbl">Total KK</div>
                  </div>
                  <div class="dk-kk-card">
                    <i class="fa fa-male"></i>
                    <div class="dkkc-num">{{ dataKeluarga.kk_laki_laki }}</div>
                    <div class="dkkc-lbl">KK Laki-laki</div>
                  </div>
                  <div class="dk-kk-card">
                    <i class="fa fa-female"></i>
                    <div class="dkkc-num">{{ dataKeluarga.kk_perempuan }}</div>
                    <div class="dkkc-lbl">KK Perempuan</div>
                  </div>
                </div>
                <div class="row mt-24">
                  <div class="col-md-6">
                    <template v-if="dataKeluarga.sumber_air_minum && dataKeluarga.sumber_air_minum.length">
                      <div class="dk-sec-title">Sumber Air Minum</div>
                      <div class="dk-chip-list mb-20">
                        <div class="dk-data-chip" v-for="item in dataKeluarga.sumber_air_minum" :key="item.kode">
                          <i class="fa fa-tint"></i>
                          <span>{{ labelAirMinum(item.kode) }}</span>
                          <strong>{{ item.total }} KK</strong>
                        </div>
                      </div>
                    </template>
                    <template v-if="dataKeluarga.sumber_penerangan && dataKeluarga.sumber_penerangan.length">
                      <div class="dk-sec-title">Sumber Penerangan</div>
                      <div class="dk-chip-list mb-20">
                        <div class="dk-data-chip" v-for="item in dataKeluarga.sumber_penerangan" :key="item.kode">
                          <i class="fa fa-lightbulb-o"></i>
                          <span>{{ labelPenerangan(item.kode) }}</span>
                          <strong>{{ item.total }} KK</strong>
                        </div>
                      </div>
                    </template>
                  </div>
                  <div class="col-md-6">
                    <template v-if="dataKeluarga.jenis_lantai && dataKeluarga.jenis_lantai.length">
                      <div class="dk-sec-title">Jenis Lantai</div>
                      <div class="dk-chip-list mb-20">
                        <div class="dk-data-chip" v-for="item in dataKeluarga.jenis_lantai" :key="item.kode">
                          <i class="fa fa-th-large"></i>
                          <span>{{ labelLantai(item.kode) }}</span>
                          <strong>{{ item.total }} KK</strong>
                        </div>
                      </div>
                    </template>
                    <template v-if="dataKeluarga.jenis_dinding && dataKeluarga.jenis_dinding.length">
                      <div class="dk-sec-title">Jenis Dinding</div>
                      <div class="dk-chip-list mb-20">
                        <div class="dk-data-chip" v-for="item in dataKeluarga.jenis_dinding" :key="item.kode">
                          <i class="fa fa-columns"></i>
                          <span>{{ labelDinding(item.kode) }}</span>
                          <strong>{{ item.total }} KK</strong>
                        </div>
                      </div>
                    </template>
                    <template v-if="dataKeluarga.jenis_atap && dataKeluarga.jenis_atap.length">
                      <div class="dk-sec-title">Jenis Atap</div>
                      <div class="dk-chip-list">
                        <div class="dk-data-chip" v-for="item in dataKeluarga.jenis_atap" :key="item.kode">
                          <i class="fa fa-home"></i>
                          <span>{{ labelAtap(item.kode) }}</span>
                          <strong>{{ item.total }} KK</strong>
                        </div>
                      </div>
                    </template>
                  </div>
                </div>
              </div>

              <!-- SARANA PRASARANA -->
              <div class="dk-tab-body" v-show="activeTab === 'sarana'">
                <div class="dk-sarana-grid" v-if="saranaPrasarana.length">
                  <div class="dk-sarana-card" v-for="item in saranaPrasarana" :key="item.id">
                    <div class="dk-sarana-ico" :class="item.jumlah_unit > 0 ? 'active' : ''">
                      <i :class="getSaranaIcon(item.id)"></i>
                    </div>
                    <div class="dk-sarana-name">{{ item.nama_data }}</div>
                    <div class="dk-sarana-cnt" :class="item.jumlah_unit > 0 ? 'has-val' : 'zero-val'">
                      {{ item.jumlah_unit }} <span>unit</span>
                    </div>
                  </div>
                </div>
                <div class="dk-empty" v-else>
                  <i class="fa fa-building fa-3x text-grey mb-10"></i>
                  <p class="text-grey">Data belum tersedia</p>
                </div>
              </div>

              <!-- BANTUAN SOSIAL -->
              <div class="dk-tab-body" v-show="activeTab === 'bantuan'">
                <div class="row">
                  <div class="col-md-6 mb-20">
                    <div class="dk-ban-card">
                      <div class="dk-ban-head fam"><i class="fa fa-users mr-2"></i>Bantuan Keluarga</div>
                      <div class="dk-ban-body">
                        <div class="dk-ban-row" v-for="(val, key) in bantuanSosial.keluarga" :key="key">
                          <span class="dk-ban-name">{{ formatBantuanKey(key) }}</span>
                          <span class="dk-ban-val" :class="parseInt(val) > 0 ? 'has-val' : 'zero-val'">{{ val }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 mb-20">
                    <div class="dk-ban-card">
                      <div class="dk-ban-head ind"><i class="fa fa-user mr-2"></i>Bantuan Individu</div>
                      <div class="dk-ban-body">
                        <div class="dk-ban-row" v-for="(val, key) in bantuanSosial.individu" :key="key">
                          <span class="dk-ban-name">{{ formatBantuanKey(key) }}</span>
                          <span class="dk-ban-val" :class="parseInt(val) > 0 ? 'has-val' : 'zero-val'">{{ val }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const potensiKampungHelper = createNamespacedHelpers("potensiKampung");

const AGAMA_LABEL = { 1:"Kristen",2:"Katolik",3:"Islam",4:"Hindu",5:"Budha",6:"Konghucu" };
const AIR_MINUM_LABEL = { 1:"Sumur Gali",2:"Sumur Bor",3:"Mata Air",4:"PDAM",5:"Sungai",6:"Hujan",7:"Embung",8:"Air Kemasan",9:"Lainnya" };
const PENERANGAN_LABEL = { 1:"PLN",2:"Non PLN",3:"Tidak Ada" };
const LANTAI_LABEL = { 1:"Tanah",2:"Bambu",3:"Kayu/Papan",4:"Semen/Bata",5:"Ubin/Keramik" };
const DINDING_LABEL = { 1:"Tembok",2:"Kayu",3:"Bambu",4:"Lainnya" };
const ATAP_LABEL = { 1:"Beton",2:"Genteng",3:"Seng",4:"Asbes",5:"Bambu/Daun" };
const BANTUAN_LABEL = {
  pkh:"PKH", kks:"KKS", kps:"KPS", rastra:"Rastra", sembako:"Sembako",
  blt_dana_desa:"BLT Dana Desa", rumah_sehat:"Rumah Sehat", renovasi_rumah:"Renovasi Rumah",
  kip:"KIP", bsm:"BSM", kis:"KIS", bpjs_kesehatan:"BPJS Kesehatan",
  bpjs_ketenagakerjaan:"BPJS Ketenagakerjaan", kartu_pra_kerja:"Kartu Pra Kerja",
  bantuan_beasiswa:"Bantuan Beasiswa",
};
const SARANA_ICON = {
  1:"fa fa-medkit", 2:"fa fa-futbol-o", 3:"fa fa-child", 5:"fa fa-child",
  6:"fa fa-graduation-cap", 7:"fa fa-graduation-cap", 8:"fa fa-university",
  9:"fa fa-star", 12:"fa fa-graduation-cap", 13:"fa fa-graduation-cap",
  14:"fa fa-graduation-cap", 15:"fa fa-heartbeat", 16:"fa fa-stethoscope", 17:"fa fa-heartbeat",
};

export default {
  data() {
    return {
      activeTab: "peta",
      tabs: [
        { key:"peta",         label:"Peta",            icon:"fa fa-map" },
        { key:"profil",       label:"Profil",          icon:"fa fa-info-circle" },
        { key:"kependudukan", label:"Kependudukan",    icon:"fa fa-users" },
        { key:"keluarga",     label:"Data Keluarga",   icon:"fa fa-home" },
        { key:"sarana",       label:"Sarana Prasarana",icon:"fa fa-building" },
        { key:"bantuan",      label:"Bantuan Sosial",  icon:"fa fa-hand-o-up" },
      ],
    };
  },
  computed: {
    ...potensiKampungHelper.mapState(["potensiKampung", "loading"]),
    identitas()     { return this.potensiKampung?.identitas      || {}; },
    kependudukan()  { return this.potensiKampung?.kependudukan   || {}; },
    dataKeluarga()  { return this.potensiKampung?.data_keluarga  || {}; },
    saranaPrasarana(){ return this.potensiKampung?.sarana_prasarana || []; },
    bantuanSosial() {
      return {
        keluarga: this.potensiKampung?.bantuan_sosial?.keluarga || {},
        individu: this.potensiKampung?.bantuan_sosial?.individu || {},
      };
    },
    malePercent() {
      const t = this.kependudukan.total_penduduk || 0;
      return t ? Math.round((this.kependudukan.laki_laki / t) * 100) : 50;
    },
    femalePercent() { return 100 - this.malePercent; },
    oapPercent() {
      const t = this.kependudukan.total_penduduk || 0;
      return t ? Math.round((this.kependudukan.oap / t) * 100) : 0;
    },
  },
  created() { this.getPotensiKampungById(this.$route.params.id); },
  mounted()  { this.$store.commit("SET_BG", false); },
  methods: {
    ...potensiKampungHelper.mapActions(["getPotensiKampungById"]),
    labelAgama:    (k) => AGAMA_LABEL[k]     || `Agama ${k}`,
    labelAirMinum: (k) => AIR_MINUM_LABEL[k] || `Kode ${k}`,
    labelPenerangan:(k)=> PENERANGAN_LABEL[k]|| `Kode ${k}`,
    labelLantai:   (k) => LANTAI_LABEL[k]    || `Kode ${k}`,
    labelDinding:  (k) => DINDING_LABEL[k]   || `Kode ${k}`,
    labelAtap:     (k) => ATAP_LABEL[k]      || `Kode ${k}`,
    formatBantuanKey: (k) => BANTUAN_LABEL[k] || k,
    getSaranaIcon:    (id) => SARANA_ICON[id] || "fa fa-cube",
    getUmurWidth(val) {
      const vals = Object.values(this.kependudukan.kelompok_umur || {}).map(Number);
      const max = Math.max(...vals);
      return max ? Math.round((Number(val) / max) * 100) : 0;
    },
  },
};
</script>

<style scoped>
/* ── Loading ── */
.dk-loading {
  display: flex; flex-direction: column;
  align-items: center; justify-content: center;
  min-height: 400px;
}

/* ── Hero ── */
.dk-hero {
  background: linear-gradient(135deg, #0e3570 0%, #1E5DC1 100%);
  padding: 130px 0 80px;
  position: relative; overflow: hidden;
}
.dk-hero-deco-1 {
  position: absolute; top: -80px; right: -80px;
  width: 400px; height: 400px;
  background: rgba(255,255,255,.06); border-radius: 50%; pointer-events: none;
}
.dk-hero-deco-2 {
  position: absolute; bottom: -60px; left: -40px;
  width: 260px; height: 260px;
  background: rgba(255,255,255,.04); border-radius: 50%; pointer-events: none;
}
.dk-hero-inner { position: relative; z-index: 2; }
.dk-breadcrumb {
  display: inline-flex; align-items: center; gap: 6px;
  color: rgba(255,255,255,.75); font-size: 13px; font-weight: 600;
  text-decoration: none; margin-bottom: 16px;
  transition: color .2s;
}
.dk-breadcrumb:hover { color: #fff; }
.dk-tipe-badge {
  display: inline-block;
  background: rgba(255,255,255,.2); color: #fff;
  font-size: 11px; font-weight: 700; letter-spacing: .8px; text-transform: uppercase;
  padding: 4px 14px; border-radius: 20px; margin-bottom: 12px;
  backdrop-filter: blur(4px);
}
.dk-hero-title {
  color: #fff; font-size: 36px; font-weight: 800;
  margin: 0 0 16px; letter-spacing: -.5px; line-height: 1.1;
}
.dk-hero-meta { display: flex; flex-wrap: wrap; gap: 16px; }
.dk-meta-item {
  color: rgba(255,255,255,.8); font-size: 13px;
  display: inline-flex; align-items: center; gap: 5px;
}

/* ── Stats Bar ── */
.dk-stats-bar {
  background: #fff;
  box-shadow: 0 4px 20px rgba(21,73,154,.1);
}
.dk-stats-row {
  display: flex; overflow-x: auto;
  scrollbar-width: none;
}
.dk-stats-row::-webkit-scrollbar { display: none; }
.dk-stat-card {
  display: flex; align-items: center; gap: 14px;
  flex: 1; padding: 16px 24px;
  border-right: 1px solid #e2e8f0; min-width: 160px;
}
.dk-stat-card:last-child { border-right: none; }
.dk-stat-icon {
  width: 46px; height: 46px; border-radius: 12px;
  display: flex; align-items: center; justify-content: center;
  font-size: 18px; color: #fff; flex-shrink: 0;
}
.c-blue   { background: linear-gradient(135deg,#15499A,#1E5DC1); }
.c-green  { background: linear-gradient(135deg,#10b981,#059669); }
.c-orange { background: linear-gradient(135deg,#fc9500,#f59e0b); }
.c-purple { background: linear-gradient(135deg,#8b5cf6,#7c3aed); }
.dk-stat-val { font-size: 22px; font-weight: 800; color: #1e293b; line-height: 1; }
.dk-stat-lbl { font-size: 12px; color: #64748b; margin-top: 3px; }

/* ── Sidebar ── */
.dk-sidebar {
  background: #fff; border-radius: 16px;
  box-shadow: 0 8px 32px rgba(21,73,154,.12);
  overflow: hidden;
}
.dk-sb-header {
  background: linear-gradient(135deg,#0e3570,#1E5DC1);
  padding: 24px 20px; text-align: center;
}
.dk-sb-avatar {
  width: 64px; height: 64px;
  background: rgba(255,255,255,.2); border-radius: 50%;
  display: flex; align-items: center; justify-content: center;
  margin: 0 auto 12px; font-size: 28px; color: #fff;
}
.dk-sb-name {
  color: #fff; font-size: 16px; font-weight: 700;
  margin: 0 0 6px; line-height: 1.35;
}
.dk-sb-kode {
  color: rgba(255,255,255,.65); font-size: 11px;
  font-family: monospace; letter-spacing: .5px;
}
.dk-sb-body { padding: 8px 16px; }
.dk-sb-row {
  display: flex; gap: 12px; padding: 10px 0;
  border-bottom: 1px solid #e2e8f0;
}
.dk-sb-row:last-child { border-bottom: none; }
.dk-sb-icon {
  width: 32px; height: 32px; background: #EBF2FF;
  border-radius: 8px; display: flex; align-items: center;
  justify-content: center; color: #15499A; font-size: 13px;
  flex-shrink: 0; margin-top: 2px;
}
.dk-sb-label {
  font-size: 11px; color: #64748b; text-transform: uppercase;
  letter-spacing: .5px; font-weight: 600;
}
.dk-sb-val { font-size: 13px; color: #1e293b; font-weight: 600; margin-top: 2px; }
.dk-gender-block {
  padding: 14px 16px;
  background: #f8fafc; border-top: 1px solid #e2e8f0;
}
.dk-gender-title {
  font-size: 11px; font-weight: 700; text-transform: uppercase;
  letter-spacing: .5px; color: #64748b; margin-bottom: 10px;
}
.dk-gender-bar {
  height: 10px; border-radius: 20px; overflow: hidden;
  display: flex; background: #e2e8f0;
}
.dk-g-male   { background: #15499A; height: 100%; transition: width .6s ease; }
.dk-g-female { background: #f472b6; height: 100%; transition: width .6s ease; }
.dk-gender-leg {
  display: flex; justify-content: space-between;
  margin-top: 8px; font-size: 12px; font-weight: 600;
}
.dgl-m { color: #15499A; }
.dgl-f { color: #ec4899; }

/* ── Tabs ── */
.dk-tabs-wrap {
  background: #fff; border-radius: 16px;
  box-shadow: 0 8px 32px rgba(21,73,154,.12);
  overflow: hidden;
}
.dk-tab-nav {
  display: flex; overflow-x: auto; gap: 2px;
  background: #f8fafc; border-bottom: 1px solid #e2e8f0;
  padding: 0 8px; scrollbar-width: none;
}
.dk-tab-nav::-webkit-scrollbar { display: none; }
.dk-tab-btn {
  display: inline-flex; align-items: center; gap: 6px;
  padding: 14px 16px; background: none; border: none;
  font-size: 13px; font-weight: 600; color: #64748b;
  cursor: pointer; white-space: nowrap;
  border-bottom: 3px solid transparent;
  transition: all .2s; outline: none;
}
.dk-tab-btn:hover { color: #15499A; background: rgba(21,73,154,.04); }
.dk-tab-btn.active {
  color: #15499A; border-bottom-color: #15499A;
  background: rgba(21,73,154,.05);
}
.dk-tab-body { padding: 24px; }
.dk-map-frame { border: none; border-radius: 10px; display: block; }

/* ── Section Title ── */
.dk-sec-title {
  font-size: 12px; font-weight: 700; text-transform: uppercase;
  letter-spacing: .6px; color: #15499A;
  margin-bottom: 12px; padding-bottom: 8px;
  border-bottom: 2px solid #EBF2FF;
}

/* ── Profil Tab ── */
.dk-visi-card, .dk-misi-card {
  background: #EBF2FF; border-radius: 12px;
  padding: 20px; height: 100%; border-left: 4px solid #15499A;
}
.dk-misi-card { border-left-color: #fc9500; background: #fff8f0; }
.dk-vc-icon {
  width: 36px; height: 36px; border-radius: 8px;
  display: flex; align-items: center; justify-content: center;
  color: #fff; font-size: 15px; margin-bottom: 10px;
}
.visi-icon { background: #15499A; }
.misi-icon { background: #fc9500; }
.dk-visi-card h5 { font-size: 15px; font-weight: 700; color: #15499A; margin-bottom: 8px; }
.dk-misi-card h5 { font-size: 15px; font-weight: 700; color: #fc9500; margin-bottom: 8px; }
.dk-visi-card p, .dk-misi-card p {
  font-size: 13px; color: #64748b; line-height: 1.6; margin: 0;
}
.dk-info-grid {
  display: grid; grid-template-columns: repeat(auto-fill,minmax(190px,1fr)); gap: 12px;
}
.dk-ig-item {
  background: #f8fafc; border: 1px solid #e2e8f0;
  border-radius: 10px; padding: 12px 16px;
}
.dk-ig-lbl {
  display: block; font-size: 10px; font-weight: 700;
  text-transform: uppercase; letter-spacing: .5px; color: #94a3b8; margin-bottom: 5px;
}
.dk-ig-val { font-size: 14px; font-weight: 600; color: #1e293b; }
.dk-code {
  background: #EBF2FF; color: #15499A; padding: 2px 8px;
  border-radius: 4px; font-size: 12px;
}
.dk-pill {
  display: inline-block; font-size: 11px; font-weight: 700;
  padding: 3px 10px; border-radius: 20px; color: #fff;
}
.dk-pill.primary { background: #15499A; }
.dk-pill.success  { background: #10b981; }

/* ── Kependudukan Tab ── */
.dk-kep-grid {
  display: grid; grid-template-columns: repeat(4,1fr); gap: 12px;
}
.dk-kep-card {
  background: #EBF2FF; border-radius: 12px; padding: 16px;
  text-align: center; border-top: 3px solid #15499A;
}
.dk-kep-card.green  { background: #ecfdf5; border-top-color: #10b981; }
.dk-kep-card.pink   { background: #fdf2f8; border-top-color: #ec4899; }
.dk-kep-card.orange { background: #fff8f0; border-top-color: #fc9500; }
.dk-kep-card i { font-size: 22px; color: #15499A; display: block; margin-bottom: 8px; }
.dk-kep-card.green  i { color: #10b981; }
.dk-kep-card.pink   i { color: #ec4899; }
.dk-kep-card.orange i { color: #fc9500; }
.dkc-num { font-size: 20px; font-weight: 800; color: #1e293b; line-height: 1; }
.dkc-lbl { font-size: 11px; color: #64748b; margin-top: 4px; }
.dk-prog-item { margin-bottom: 6px; }
.dk-prog-head {
  display: flex; justify-content: space-between;
  font-size: 12px; color: #64748b; margin-bottom: 6px;
}
.dk-prog-track {
  height: 8px; background: #e2e8f0; border-radius: 20px; overflow: hidden;
}
.dk-prog-fill {
  height: 100%; border-radius: 20px; transition: width .8s ease;
}
.dk-prog-fill.blue  { background: linear-gradient(90deg,#15499A,#1E5DC1); }
.dk-prog-fill.green { background: linear-gradient(90deg,#10b981,#059669); }
.dk-agama-list { display: flex; flex-wrap: wrap; gap: 8px; }
.dk-agama-chip {
  display: inline-flex; align-items: center; gap: 8px;
  background: #EBF2FF; border-radius: 20px; padding: 6px 14px;
  font-size: 13px; font-weight: 600; color: #15499A;
}
.dac-num {
  background: #15499A; color: #fff; font-size: 11px;
  font-weight: 700; padding: 2px 8px; border-radius: 20px;
}
.dk-umur-list { display: flex; flex-direction: column; gap: 5px; }
.dk-umur-row { display: flex; align-items: center; gap: 8px; }
.dk-umur-lbl {
  width: 52px; font-size: 11px; color: #64748b;
  font-weight: 600; text-align: right; flex-shrink: 0;
}
.dk-umur-track { flex: 1; height: 8px; background: #e2e8f0; border-radius: 20px; overflow: hidden; }
.dk-umur-fill {
  height: 100%; background: linear-gradient(90deg,#15499A,#1E5DC1);
  border-radius: 20px; transition: width .6s ease;
}
.dk-umur-num { width: 22px; font-size: 11px; font-weight: 700; color: #1e293b; text-align: right; }

/* ── Data Keluarga Tab ── */
.dk-kk-row { display: flex; gap: 12px; margin-bottom: 4px; }
.dk-kk-card {
  flex: 1; background: #f8fafc; border: 1px solid #e2e8f0;
  border-top: 3px solid #15499A; border-radius: 12px; padding: 16px; text-align: center;
}
.dk-kk-card i { font-size: 22px; color: #15499A; display: block; margin-bottom: 8px; }
.dkkc-num { font-size: 24px; font-weight: 800; color: #1e293b; line-height: 1; }
.dkkc-lbl { font-size: 11px; color: #64748b; margin-top: 4px; }
.dk-chip-list { display: flex; flex-direction: column; gap: 8px; }
.dk-data-chip {
  display: flex; align-items: center; gap: 10px;
  background: #f8fafc; border: 1px solid #e2e8f0;
  border-radius: 10px; padding: 10px 14px;
}
.dk-data-chip i { color: #15499A; width: 16px; text-align: center; flex-shrink: 0; }
.dk-data-chip span { flex: 1; font-size: 13px; color: #1e293b; font-weight: 500; }
.dk-data-chip strong { font-size: 13px; color: #15499A; font-weight: 700; }

/* ── Sarana Prasarana Tab ── */
.dk-sarana-grid {
  display: grid; grid-template-columns: repeat(auto-fill,minmax(150px,1fr)); gap: 12px;
}
.dk-sarana-card {
  background: #f8fafc; border: 1px solid #e2e8f0;
  border-radius: 12px; padding: 16px; text-align: center;
  transition: all .2s;
}
.dk-sarana-card:hover { border-color: #15499A; box-shadow: 0 4px 16px rgba(21,73,154,.1); }
.dk-sarana-ico {
  width: 48px; height: 48px; background: #e2e8f0;
  border-radius: 12px; display: flex; align-items: center;
  justify-content: center; margin: 0 auto 10px;
  font-size: 20px; color: #94a3b8; transition: all .2s;
}
.dk-sarana-ico.active { background: #EBF2FF; color: #15499A; }
.dk-sarana-name { font-size: 11px; font-weight: 600; color: #1e293b; margin-bottom: 8px; line-height: 1.3; }
.dk-sarana-cnt { font-size: 16px; font-weight: 800; }
.dk-sarana-cnt.has-val { color: #15499A; }
.dk-sarana-cnt.zero-val { color: #94a3b8; }
.dk-sarana-cnt span { font-size: 11px; font-weight: 400; color: #64748b; margin-left: 2px; }
.dk-empty { text-align: center; padding: 60px 20px; }

/* ── Bantuan Sosial Tab ── */
.dk-ban-card {
  background: #fff; border: 1px solid #e2e8f0;
  border-radius: 14px; overflow: hidden;
}
.dk-ban-head {
  padding: 14px 20px; font-size: 14px; font-weight: 700; color: #fff;
}
.dk-ban-head.fam { background: linear-gradient(135deg,#15499A,#1E5DC1); }
.dk-ban-head.ind { background: linear-gradient(135deg,#10b981,#059669); }
.dk-ban-body { padding: 4px 0; }
.dk-ban-row {
  display: flex; justify-content: space-between; align-items: center;
  padding: 9px 20px; border-bottom: 1px solid #e2e8f0;
}
.dk-ban-row:last-child { border-bottom: none; }
.dk-ban-name { font-size: 13px; color: #1e293b; font-weight: 500; }
.dk-ban-val {
  font-size: 13px; font-weight: 700; padding: 3px 12px;
  border-radius: 20px; min-width: 36px; text-align: center;
}
.dk-ban-val.has-val { background: rgba(16,185,129,.12); color: #10b981; }
.dk-ban-val.zero-val { background: #f1f5f9; color: #94a3b8; }

/* ── Responsive ── */
@media (max-width: 768px) {
  .dk-hero-title { font-size: 26px; }
  .dk-kep-grid   { grid-template-columns: repeat(2,1fr); }
  .dk-kk-row     { flex-wrap: wrap; }
  .dk-kk-card    { min-width: 100px; }
  .dk-tab-btn span { display: none; }
  .dk-tab-btn i  { font-size: 16px; }
  .dk-tab-btn    { padding: 12px 14px; }
}
</style>
